import * as React from 'react';
import IconBase, { IconBaseProps } from '../components/Icons/IconBase';
const props = {};

const SvgPersonWalkingNo = (allProps: IconBaseProps) => {
  return (
    <IconBase {...allProps}>
      <svg
        width="1em"
        height="1em"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M8.77588 3.55801C8.77588 4.2542 9.05244 4.92188 9.54472 5.41416C10.037 5.90644 10.7047 6.18301 11.4009 6.18301C12.0971 6.18301 12.7648 5.90644 13.257 5.41416C13.7493 4.92188 14.0259 4.2542 14.0259 3.55801C14.0259 2.86181 13.7493 2.19413 13.257 1.70185C12.7648 1.20957 12.0971 0.933006 11.4009 0.933006C10.7047 0.933006 10.037 1.20957 9.54472 1.70185C9.05244 2.19413 8.77588 2.86181 8.77588 3.55801V3.55801Z"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12.1509 8.058C13.7417 8.05959 15.2669 8.69224 16.3918 9.81711C17.5166 10.942 18.1493 12.4672 18.1509 14.058"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8.4479 12.838C7.95719 13.4542 7.33352 13.9514 6.62353 14.2926C5.91353 14.6337 5.1356 14.8099 4.3479 14.808C3.95008 14.808 3.56854 14.65 3.28724 14.3687C3.00594 14.0874 2.8479 13.7058 2.8479 13.308C2.8479 12.9102 3.00594 12.5286 3.28724 12.2473C3.56854 11.966 3.95008 11.808 4.3479 11.808C4.68527 11.8087 5.01844 11.7332 5.32251 11.587C5.62659 11.4409 5.8937 11.2279 6.1039 10.964"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M15.6489 20.726C15.8696 21.0575 15.9495 21.4631 15.8711 21.8536C15.7927 22.244 15.5624 22.5873 15.2309 22.808C14.8994 23.0287 14.4938 23.1086 14.1033 23.0302C13.7129 22.9518 13.3696 22.7215 13.1489 22.39C12.2 20.966 11.4437 19.4225 10.8999 17.8C9.33623 18.7864 8.16049 20.2817 7.5709 22.034C7.43576 22.3993 7.16379 22.6978 6.81254 22.8662C6.46128 23.0346 6.05829 23.0597 5.68882 22.9363C5.31935 22.8129 5.01239 22.5506 4.83286 22.2049C4.65334 21.8592 4.61534 21.4572 4.7269 21.084C5.64411 18.355 7.59067 16.0919 10.1519 14.777"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M0.75 0.745003L23.25 23.245"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </IconBase>
  );
};

SvgPersonWalkingNo.displayName = 'SvgPersonWalkingNo';
export default SvgPersonWalkingNo;
